import { Component, computed, effect } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent, RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../environments/default/environment';
import { CommonModule } from '@angular/common';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { PurpleLoaderService, PurpleApiErrorService, PurpleBreakpointsService, PurpleApiError, PurpleApiErrorPage, PurpleLoaderComponent, PurpleApiErrorWrapperComponent } from '@purple-lib/purple-utilities';

@Component({
    selector: 'app-root',
    templateUrl: './app-broker.component.html',
    styleUrls: ['./app-broker.component.scss'],
    imports: [CommonModule, PurpleLoaderComponent, NzDrawerModule, NzModalModule, PurpleApiErrorWrapperComponent]
})
export class AppBrokerComponent {

  constructor(public loaderSvc: PurpleLoaderService, private router: Router, private errorInterceptorSvc: PurpleApiErrorService,  public breakSvc: PurpleBreakpointsService) {

    this.router.events.subscribe((e: any) => {
      this.navigationInterceptor(e);
    });

    effect(() => {
      let errorInfo = this.errorInterceptorSvc.errorState();

      if (errorInfo != undefined) {
        switch (errorInfo.errorStatus) {
          case 0:
            this.loaderSvc.removeAllRequest(this.loaderId);
            break;

          case 401:
            //console.log("Errore 401")
            this.throttleLogout.next(1);
            break;

          default:
            break;
        }
      }else{
        this.errorInfo = undefined;
      }
    })
  }

  loaderId: string = "broker";
  loaderSpeed: number = environment.LOADER_SPEED; 
  loaderWidth = computed(() => {
    const deviceSize = this.breakSvc.breakPointDevice();
    return deviceSize === 'desktop'
      ? environment.LOADER_DESKTOP_WIDTH
      : environment.LOADER_MOBILE_WIDTH;
  });

  private throttleLogout = new Subject<any>();
  errorInfo: PurpleApiError | undefined = undefined;
  sub: Subject<void> = new Subject();

  enableErrorPages: PurpleApiErrorPage[] = [
    {
      errorStatus: 0,
      errorTitle: "OPS SOMETHING WENT WRONG...",
      errorDescription: "It appears there was an error connecting to the server. Try reloading the page again.",

    },
    {
      errorStatus: 404,
      errorTitle: "OPS PAGE NOT FOUND...",
      errorDescription: "It appears when router not exist.",
      
    },
    {
      errorStatus: 401,
      errorTitle: "YOU ARE NOT AUTHENTICATED",
      errorDescription: "You have to make login to access this page.",
      
    }
  ]

  ngOnInit() {
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loaderSvc.addRequest(this.loaderId);
    }
    if (event instanceof NavigationEnd) {
      this.loaderSvc.removeRequest(this.loaderId, environment.ROUTING_LOADER_DELAY);
    }

    if (event instanceof NavigationCancel) {
      this.loaderSvc.removeRequest(this.loaderId, environment.ROUTING_LOADER_DELAY);
    }
    if (event instanceof NavigationError) {
      this.errorInterceptorSvc.reportError({
        errorStatus: 404,
        text: "Route not found"
      })
      this.loaderSvc.removeRequest(this.loaderId, environment.ROUTING_LOADER_DELAY);
    }
  }

  ngOnDestroy() {
    this.sub.next();
    this.sub.complete();
  }
}
